import React, { PropTypes, Component } from 'react';
import { Motion, spring } from 'react-motion';
import classNames from 'classnames';
import CSSPropertyOperations from 'react/lib/CSSPropertyOperations';
import Portal from 'components/Portal';
import { Shadow, Colors } from 'Css';

const ESC = 27;

const css = oxygenCss({
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    boxShadow: Shadow[1],
    zIndex: 99,
    background: Colors.theme.Light.card
  }
});

export default class Drawer extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    open: PropTypes.bool,
    right: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    width: PropTypes.number,
    onRequestClose: PropTypes.func,
    onRequestOpen: PropTypes.func,
    closeOnEsc: PropTypes.bool,
    slide: PropTypes.bool
  };

  static defaultProps = {
    open: false,
    width: 390,
    slide: true,
    closeOnEsc: true
  };

  componentWillMount() {
    this._app = document.getElementById('root');
    document.addEventListener('keyup', this.handleKey);
  }

  componentWillUnmount() {
    const { slide } = this.props;
    slide &&
      CSSPropertyOperations.setValueForStyles(this._app, { right: 0, left: 0 });
    document.removeEventListener('keyup', this.handleKey);
  }

  handleRequestOpen = () => {
    const { open, onRequestOpen } = this.props;
    if (!open && onRequestOpen) {
      onRequestOpen();
    }
  };

  handleRequestClose = () => {
    const { open, onRequestClose } = this.props;
    if (open && onRequestClose) {
      onRequestClose();
    }
  };

  handleRest = () => {
    const { slide, open, onOpen, onClose } = this.props;
    if (open && onOpen) {
      onOpen();
    } else if (!open && onClose) {
      onClose();
    }
    if (!open && slide) {
      CSSPropertyOperations.setValueForStyles(this._app, { right: 0, left: 0 });
    }
  };

  handleKey = event => {
    const { keyCode } = event;
    const { closeOnEsc, onRequestClose } = this.props;
    if (keyCode === ESC && closeOnEsc && onRequestClose) {
      onRequestClose();
    }
  };

  render() {
    const { open, slide, children, right, width, className } = this.props;
    const classes = classNames(css.container, className);
    return (
      <Motion
        style={{
          width: spring(width, { stiffness: 300, damping: 25 }),
          x: spring(open ? 1 : 0, { stiffness: 300, damping: 25 }),
          open: spring(open ? 1 : 0)
        }}
        onRest={this.handleRest}
      >
        {interpolated => {
          if (interpolated.open > 0) {
            const { x, width: interpolatedWidth } = interpolated;
            const style = {
              width: interpolatedWidth,
              left: right ? null : -interpolatedWidth,
              right: right ? -interpolatedWidth : null,
              transform: `translate3d(${right ? 0 : x * interpolatedWidth}px, ${
                right ? -x * interpolatedWidth : 0
              }px, 0)`
            };
            slide &&
              CSSPropertyOperations.setValueForStyles(this._app, {
                right: right ? x * interpolatedWidth : 0,
                left: right ? 0 : x * interpolatedWidth
              });

            return (
              <Portal className={classes} style={style}>
                {children}
              </Portal>
            );
          }
          return null;
        }}
      </Motion>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Drawer/Drawer.js